import React, { useState, useEffect } from "react";
import Hidden from "@material-ui/core/Hidden";
import { connect } from "react-redux";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import TabPanel from "./TabPanel";
import Iframe from "../Iframe";
import { getCurrentMainRoute } from "../../configs/menuProfile";
import { mixUrlWithParamns } from "../../utils/objectManipulations";
import useStyles from "./style";
import TabHeader from "./TabHeader";
import { getApplicationToken } from '../../api/api-client';

import { useHistory, useRouteMatch } from "react-router-dom";

function ScrollableTabsButtonAuto({
  mainGroup,
  groups,
  location,
  filteredBranchString,
  filteredBranchRegionString,
  operationsType,
  filterPeriod,
  filteredFarm,
  filterAssignOnValidate,
  filterAssignOnAdd,
  setNoCache,
  noCache,
  filteredTransportersString,
  filteredOCsHasDocumentPersist,
  filterOCReseted
}) {
  const classes = useStyles();
  const history = useHistory();
  const { url } = useRouteMatch();

  const [currentUrl, setCurrentUrl] = useState(0);
  const [loadingOrderNumber, setLoadingOrderNumber] = useState("");

  const mainRoute = getCurrentMainRoute(mainGroup, groups, location.pathname);
  const actions = mainRoute && mainRoute.subRoutes ? mainRoute.subRoutes : [];

  const currentAction = actions.find(action => action.route === location.pathname);
  const urlPortions = url.split("/").filter((x) => x);

  useEffect(() => {
    if (urlPortions.length <= 1) {
      return setCurrentUrl(0);
    }
    const valueIndex = actions.findIndex((action) => action.route === url);
    setCurrentUrl(valueIndex);
  }, [url, urlPortions, actions]);

  const selectURL = (url) => {
    let paramns = { noCache, token: getApplicationToken() };

    switch (url) {
      case "Backoffice/validateDocumentsIn":
      case "Transporter/validateDocumentsIn":
      case "Transporter/listLoadingOrders":
      case "Transporter/loadingOrdersCanceled":
      case "Backoffice/loadingOrdersCanceled":
      case "Backoffice/loadingOrdersWithDocuments":
      case "Backoffice/loadingOrdersDocuments":
      case "Backoffice/sendDocumentsIn":
      case "Warehouse/loadingOrders":
      case "Warehouse/timeline":
        if (filteredBranchRegionString) {
          paramns.branchRegions = filteredBranchRegionString;
        }
        if (filteredBranchString) {
          paramns.branches = filteredBranchString;
        }
        if (url === "Warehouse/loadingOrders" || url === "Warehouse/timeline") {
          operationsType = null
          if (loadingOrderNumber) {
            paramns.loadingOrderNumber = loadingOrderNumber;
          }
        }
        if (url !== "Transporter/validateDocumentsIn" && !!operationsType) {
          paramns.operations_type = operationsType
            .map(e => e.value)
            .join(',');
        }
        if ((url === "Transporter/listLoadingOrders" || url === "Transporter/loadingOrdersCanceled") && filteredTransportersString) {
          paramns.transporters = filteredTransportersString;
        }
        paramns.days_to_search = filterPeriod ? filterPeriod : 3;

        if (filteredOCsHasDocumentPersist) {
          paramns.filtered_ocs_has_document = filteredOCsHasDocumentPersist
        }
        paramns.filtered_subscription_status_validate = filterAssignOnValidate?.map(f => f.value).join(',');
        paramns.filtered_subscription_status_add = filterAssignOnAdd?.map(f => f.value).join(',');
        paramns.filtered_oc_reseted = filterOCReseted.value
        break;
      case "Farmer/loadingOrders":
      case "Farmer/timeline":
        if (filteredFarm) {
          paramns.farmSelected = filteredFarm.id;
        }
        if (loadingOrderNumber) {
          paramns.loadingOrderNumber = loadingOrderNumber;
        }
        break;
      default:
        break;
    }

    return mixUrlWithParamns(url, paramns);
  };

  const handleChangeTab = (event, newURL) => {
    setCurrentUrl(newURL);
    setNoCache();
    history.push(actions[newURL].route);
  };

  const a11yProps = (index) => ({
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  });

  const pageWasFound = currentAction && actions && actions[currentUrl];

  return pageWasFound ? (
    <div className={classes.root}>
      <TabHeader
        onFilterOC={lONumber => setLoadingOrderNumber(lONumber)}
        action={actions[currentUrl].route}
        groups={groups}
        mainGroup={mainGroup} />
      <Hidden smDown>

        <Tabs
          value={currentUrl}
          onChange={handleChangeTab}
          indicatorColor="secondary"
          scrollButtons="auto"
          variant="scrollable"
          textColor="primary"
          aria-label="tab to chose am option"
        >
          {actions.map((action, index) => {
            return (
              !action.notShowInTab && (
                <Tab key={index} label={action.title} {...a11yProps(index)} />
              )
            );
          })}
        </Tabs>
        {actions.map((action, index) => {
          return (
            <TabPanel
              key={index}
              label={action.title}
              value={currentUrl}
              index={index}
            >
              <Iframe url={selectURL(action.action)} />
            </TabPanel>
          );
        })}
      </Hidden>
      <Hidden smUp>
        <Iframe url={selectURL(currentAction.action)} />
      </Hidden>
    </div>
  ) : <h1 style={{ textAlign: "center", marginTop: "20vh" }}>404 - Page not found!</h1>;
}

const mapState = (state) => ({
  noCache: state.navigation.noCache,
  mainGroup: state.auth.user.mainGroup,
  groups: state.auth.user.groups,
  filteredBranchString: state.branches.filteredBranchString,
  filteredBranchRegionString: state.branches.filteredBranchRegionString,
  filterAssignOnValidate: state.loadingOrders.filterAssignUserOnValidate,
  filterAssignOnAdd: state.loadingOrders.filterAssignUserOnAdd,
  filterOCReseted: state.loadingOrders.filterOCResetedPersist,
  operationsType: state.loadingOrders.filteredOperation,
  filterPeriod: state.branches.filterPeriod,
  filteredFarm: state.farms.filteredFarm,
  filteredOCsHasDocumentPersist: state.loadingOrders.filteredOCsHasDocumentPersist,
  filteredTransportersString: state.transporters.filteredTransportersString
});

const mapDispatch = (dispatch) => ({
  setNoCache: (payload = null) => dispatch.navigation.setNoCache(payload),
});

export default connect(mapState, mapDispatch)(ScrollableTabsButtonAuto);
